import React from "react";
import { useInView } from "react-intersection-observer";
import { MotionBox } from "./motion-chakra";

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  direction?: "up" | "left" | "right";
  width?: string;
  /** Skip scroll-triggered detection and animate in as soon as the component mounts.
   * Use for above-the-fold content that's visible immediately on page load. */
  onMount?: boolean;
}

const offsets: Record<
  NonNullable<RevealProps["direction"]>,
  [number, number]
> = {
  up: [0, 28],
  left: [-28, 0],
  right: [28, 0],
};

const Reveal: React.FC<RevealProps> = ({
  children,
  delay = 0,
  direction = "up",
  width,
  onMount = false,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.15,
  });
  const [x, y] = offsets[direction];
  const shouldShow = onMount || inView;

  return (
    <MotionBox
      ref={onMount ? undefined : ref}
      width={width}
      initial={{ opacity: 0, x, y }}
      animate={
        shouldShow
          ? {
              opacity: 1,
              x: 0,
              y: 0,
              transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
            }
          : {}
      }
    >
      {children}
    </MotionBox>
  );
};

export default Reveal;
